import axios from '../utils/axios';

export default function postCompetitionBulkAction(adminId, data) {
    
    return (
        axios.post('/admin/'+adminId + '/competition/user/admin/bulk-action-by-score', data)
    )
}
